import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { signal, props } from 'cerebral/tags'
import Select from './select'

export default connect(
  {
    init: signal`selectr.init`,
    name: props`name`
  },
  class SelectInitializer extends Component {
    componentWillMount() {
      const {
        init,
        name,
        options = [],
        createTags = true,
        payload = {},
        validationRules = []
      } = this.props
      init({ name, options, createTags, payload, validationRules })
    }

    render() {
      const { name, overrideStyles, editable = true, tagClicked } = this.props
      return (
        <Select
          editable={editable}
          tagClicked={tagClicked}
          namespace={name}
          overrideStyles={overrideStyles}
        />
      )
    }
  }
)
